<template>
    <div>
        <h5>Headers</h5>
        <p>Across the top are our internal field names. Below these are shown the mappings that you have created that map your field names to ours. You can add, edit or delete these.</p>
        <div class="headers-holder">
            <table class="headers-list">
                <tr>
                    <th>Saved Headers</th>
                    <th></th>
                    <th v-for="(field, j) in Object.keys(baxter_headers)"  v-bind:key='j'>{{baxter_headers[field]['cust_name']}}</th>
                    <th>Created by</th>
                    <th>On</th>
                </tr>
                <template v-for="(id, i) in Object.keys(headers)"  >
                    <tr v-bind:key='i' v-if="headers[id].name != 'Default Header Fields'">
                        <template v-if="id !== editing_id">
                            <td><strong>{{ headers[id].name }}</strong></td>
                            <td><a href="#" @click.prevent="editHeader(id)">Edit</a></td>
                            <td v-for="(field, j) in Object.keys(baxter_headers)"  v-bind:key='j'><span v-if="headers[id].fields[field]">{{headers[id].fields[field].cust_name}}</span> </td>
                        </template>
                        <template v-else>
                            <td><input v-model="save_name" type="text" /></td>
                            <td><a href="#" @click.prevent="saveHeader()">Save</a> | <a href="#" @click.prevent="deleteHeader()" style="color:red">Delete</a> | <a href="#" @click.prevent="saveHeaderCancel()">Cancel</a></td>
                            <td v-for="(field, j) in Object.keys(baxter_headers)"  v-bind:key='j'>
                                <input v-model="save_fields[field]" type="text" />
                            </td>
                        </template>
                        <td>{{ headers[id].username }}</td>
                        <td>{{ unix2date(headers[id].created) }}</td>
                    </tr>
                </template>
                <tr>
                    <template v-if="0 !== editing_id">
                        <td></td>
                        <td><a href="#" @click.prevent="editHeader(0)">Add New</a></td>
                    </template>
                    <template v-else>
                        <td><input v-model="save_name" type="text" /></td>
                        <td><a href="#" @click.prevent="saveHeader()">Save</a></td>
                        <td v-for="(field, j) in Object.keys(baxter_headers)"  v-bind:key='j'>
                            <input v-model="save_fields[field]" type="text" />
                        </td>
                    </template>
                </tr>
            </table>
        </div>
    </div>
</template>


<script>
    import CsvService from '@/core/api/csv/csv.service3';
    // import DrugService from '@/core/api/drug/drug.service';
    import csvMixin from './csvMixin';

    export default {
        name: 'DefaultsHeaders',
        mixins: [csvMixin],
        data() {
            return {
                headers: [],
                baxter_headers: [],
                save_fields: [],
                save_name: '',
                editing_id: false,
            };
        },
        created() {
            this.load();
        },
        methods: {
            async load() {
                this.save_fields = [];
                this.save_name = '';
                CsvService.loadDefaultHeaders()
                    .then(async (res) => {
                        this.headers = res.data.headers;
                        this.baxter_headers = this.headers[1].fields;
                    });
            },
            editHeader(id) {
                this.editing_id = id;
                this.save_name = this.headers[id].name;
                Object.keys(this.baxter_headers).forEach((field) => {
                    this.save_fields[field] = this.headers[id].fields[field] ? this.headers[id].fields[field].cust_name : '';
                });
            },
            saveHeaderCancel() {
                this.editing_id = false;
            },
            saveHeader() {
                const data = {};
                data.action = 'defaultsheaders';
                data.fields = {};
                data.name = this.save_name;
                data.id = this.editing_id;

                Object.keys(this.baxter_headers).forEach((field) => {
                    data.fields[field] = (this.save_fields[field]);
                });

                CsvService.saveDefaultsHeaders(data)
                    .then(async () => {
                        this.editing_id = false;
                        this.load();
                    });
            },
            deleteHeader() {
                const data = {};
                data.action = 'defaultsheaders';
                data.delete_id = this.editing_id;

                CsvService.saveDefaultsHeaders(data)
                    .then(async () => {
                        this.editing_id = false;
                        this.load();
                    });
            },
        },
    };
</script>
